import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import '../styles/Resources.css';
import { FaDownload } from 'react-icons/fa';


const heroImageURL = "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=2070&auto=format&fit=crop";

const resources = [
  {
    title: "Company Profile",
    description: "An in-depth look at our mission, operational scale, and the values that drive our commitment to excellence.",
    previewImage: "/profile/Laxmi_hospitality_Services_Profile_page-01-preview.png",
    downloadLink: "https://laxmihospitalityservices.in/Laxmi_Hospitality_Services_Profile.pdf"
  },
  {
    title: "Company Certificates",
    description: "View our official certifications, including UDYAM, MSME, Quality Management, GST  and other approved documents that underscore our quality.",
    previewImage: "/profile/certificates-preview.png",
    downloadLink: "https://laxmihospitalityservices.in/certificates.pdf"
  },
];

// --- Component ---

function Resources() {
  return (
    <>
   <Helmet>
    <title>Resources & Downloads | Laxmi Hospitality Services</title>
    <meta 
        name="description" 
        content="Access and download official documents from Laxmi Hospitality Services, including our corporate profile, service brochures, and quality certifications for industrial catering."
    />
    <meta name="robots" content="index, follow" />
    <link rel="canonical" href="https://laxmihospitalityservices.in/resources" />

    {/* -------- Open Graph (Social Media) -------- */}
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://laxmihospitalityservices.in/resources" />
    <meta property="og:title" content="Resources & Downloads | Laxmi Hospitality Services" />
    <meta property="og:description" content="Download official documents from Laxmi Hospitality, including our company profile and certifications." />
    <meta property="og:site_name" content="Laxmi Hospitality Services" />
    <meta property="og:locale" content="en_IN" />
    
    {/* -------- CollectionPage Structured Data -------- */}
    <script type="application/ld+json">
    {`
        {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "@id": "https://laxmihospitalityservices.in/resources",
            "name": "Resources & Downloads",
            "description": "A collection of official downloadable documents from Laxmi Hospitality Services, including our corporate profile and quality certifications.",
            "url": "https://laxmihospitalityservices.in/resources",
            "about": { "@id": "https://laxmihospitalityservices.in/#organization" },
            "publisher": { "@id": "https://laxmihospitalityservices.in/#organization" },
            "inLanguage": "en-IN",
            "hasPart": [
                {
                    "@type": "CreativeWork",
                    "name": "Company Profile",
                    "description": "An in-depth look at our mission, operational scale, and the values that drive our commitment to excellence.",
                    "url": "https://laxmihospitalityservices.in/Laxmi_Hospitality_Services_Profile.pdf"
                },
                {
                    "@type": "CreativeWork",
                    "name": "Company Certificates",
                    "description": "View our official certifications, including UDYAM, MSME, GST , Quality management and other approved documents that underscore our quality.",
                    "url": "https://laxmihospitalityservices.in/Laxmi_Hospitality_Services_Profile.pdf"
                }
            ]
        }
    `}
    </script>

    {/* -------- Page-Specific Breadcrumb -------- */}
    <script type="application/ld+json">
    {`
        {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": "https://laxmihospitalityservices.in/resources/#breadcrumb",
            "name": "Website Breadcrumb",
            "itemListElement": [
                { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://laxmihospitalityservices.in/" },
                { "@type": "ListItem", "position": 2, "name": "Resources", "item": "https://laxmihospitalityservices.in/resources" }
            ]
        }
    `}
    </script>
</Helmet>
      
      <div className="lhs-resources-page-container">
        <div className="lhs-resources-banner">
          <img
            src={heroImageURL}
            alt="Professional documents and resources"
            className="lhs-resources-banner-image"
          />
          <div className="lhs-resources-banner-overlay">
            <h1 className="lhs-resources-banner-title">Resources</h1>
            <p className="lhs-resources-banner-breadcrumb">
              <Link to="/" className="lhs-resources-breadcrumb-link">Home</Link> / Resources
            </p>
          </div>
        </div>

        <div className="lhs-resources-content-wrapper">
          <div className="lhs-resources-header">
            <h2 className="lhs-resources-title">Our Commitment in Detail</h2>
            <p className="lhs-resources-subtitle">
              Here you can find and download important documents related to our services, standards, and certifications.
            </p>
          </div>

          <div className="lhs-resources-grid">
            {resources.map((resource, index) => (
              <div className="lhs-resource-card" key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                <div className="lhs-resource-card-image-wrapper">
                  {/* --- THIS IS THE CHANGE --- */}
                  <div 
                    className="lhs-resource-card-image"
                    style={{ backgroundImage: `url(${resource.previewImage})` }}
                    aria-label={`Preview of ${resource.title}`}
                  ></div>
                </div>
                <div className="lhs-resource-card-content">
                  <h3 className="lhs-resource-card-title">{resource.title}</h3>
                  <p className="lhs-resource-card-description">{resource.description}</p>
                   <a href={resource.downloadLink} download className="lhs-resource-card-download-btn">
                      <FaDownload />
                      <span>Download</span>
                   </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default Resources;

